import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import "./styles.css";

export const RelatedArticles = ({ relatedArticles, linkPrefix }) => {
  return (
    <div className="related-articles-container">
      <div className="related-articles-header">Realted Articles</div>
      <div className="related-articles-wrapper">
        {relatedArticles.map(({ node: relatedArticle }) => {
          const link = linkPrefix
            ? `/${linkPrefix}/${relatedArticle.compose__page?.[0].slug}`
            : `/${relatedArticle.compose__page?.[0].slug}`;

          return (
            <div className="related-article" key={relatedArticle.id}>
              <div
                className="article-image"
                style={{ backgroundColor: relatedArticle.color }}
              >
                <Link to={link}>
                  <GatsbyImage
                    image={
                      getImage(
                        relatedArticle.image.localFile.childImageSharp
                          .gatsbyImageData
                      )!
                    }
                    alt={relatedArticle.image.title}
                  />
                </Link>
              </div>
              <Link className="article-link-text" to={link}>
                {relatedArticle.compose__page?.[0].title}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};
